export const getOrderRecipients = recipients => {
  const sortedRecipients =
    !recipients || !recipients.length
      ? []
      : recipients.sort(
          (a, b) => a.memberFaxRecipientId - b.memberFaxRecipientId
        );
  return sortedRecipients;
};
